export const INITIAL_STATE = {
  LOGIN_SCREEN: {},
  DASHBOARD: {},
  AUTH: null,
  APP: {},
  VISITS_SCREEN: {}
};
